import AuthService from 'src/services/api/auth.service';
import { useGetUserAssetsQuery } from 'src/store/api/retail-composite';

export const useUserAssets = () => {
  const userBk = AuthService.getUserBk();

  const result = useGetUserAssetsQuery(userBk, {
    skip: !userBk,
  });

  return {
    // checking isError won't help because it will be reset after re-render unlike error object
    isLoadingWithoutError: result.isLoading && !result.error,
    ...result,
  };
};
